module.exports = __webpack_public_path__ + "static/media/vanessarusu-logo-black.cf816d6d.svg";